import React from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../core';
import { ClientData, StyleOverrideNames } from '../fr-investment/types';
import { BaseMixPanel, UserInfo, ThemeType } from '../types';
import { constants } from './constants';

export type ShowModalType = (
  name: string,
  options: Record<string, unknown>,
) => void;
export type LogoutUserType = () => void;

export type ExternalRouteNamesOppDetails =
  | 'INVESTMENT_WIZARD'
  | 'KYC'
  | 'SUITABILITY'
  | 'QUALIFICATION_REQUIRED';

export interface OpportunityDetailsFrontendParams {
  userInfo: UserInfo;
  basePath: string;
  logoutUser: LogoutUserType;
  showModal: ShowModalType;
  opportunityId: string;
  clientData: ClientData;
  styleOverrides?: Partial<Record<StyleOverrideNames, string>>;
  mixPanel: BaseMixPanel;
  externalRoutes: Record<ExternalRouteNamesOppDetails, string>;
  theme?: ThemeType;
}

export const OpportunityDetailsMicroFrontend = (
  props: SpecificMicroFrontendProps<OpportunityDetailsFrontendParams>,
) => {
  return (
    <MicroFrontend<OpportunityDetailsFrontendParams>
      entryPointUrl={props.entryPointUrl}
      history={props.history}
      name={constants.MFE_NAME}
      exposedPath={constants.MC_OPPORTUNITY_DETAILS_EXPOSED_PATH}
      userInfo={props.userInfo}
      basePath={props.basePath}
      params={props.params}
    />
  );
};
